import Vue from "vue";
import Vuex from "vuex";
import VuexORM from "@vuex-orm/core";
import VuexORMAxios from "@vuex-orm/plugin-axios";
import api from '../services/api.hermes'
import database from "./database";
import { auth } from './auth.module';

Vue.use(Vuex);

VuexORM.use(VuexORMAxios, {
  axios: api
});

export default new Vuex.Store({
  plugins: [
    VuexORM.install(database),
  ],
  modules: {
    auth
  },
  state: {
    snacktext: ""
  },
  mutations: {
    // Update the snackbar text
    setText(state, payload) {
      state.snacktext = payload
    }
  },
  actions: {
    // The payload is the snackbar text
    setSnackBar({commit}, payload) {
      commit("setText", payload);
    },
  }
})
